"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.siloReducer = exports.siloAction = exports.siloTypes = void 0;
const silo_component_1 = __importDefault(require("./sub-components/silo.component"));
const silo_action_1 = __importDefault(require("./silo.action"));
exports.siloAction = silo_action_1.default;
const silo_reducer_1 = __importDefault(require("./silo.reducer"));
exports.siloReducer = silo_reducer_1.default;
const silo_types_1 = require("./silo.types");
Object.defineProperty(exports, "siloTypes", { enumerable: true, get: function () { return silo_types_1.siloTypes; } });
exports.default = silo_component_1.default;
